export const GoogleMapApiConfig = 'AIzaSyAtAc3Q1xCjfE1QBIIvj7Qzs_fweR7jwmw';